export default __webpack_public_path__ + "static/media/contactus_teacher.97f4d9d8.png";